<div class="title">
  <mat-icon>view_timeline</mat-icon>
  Product Templates
</div>
<div class="description">SELECT THE TEMPLATES TO FILTER BY</div>

<div class="options">
  @for (template of templates$ | async; track template) {
    <elements-filter-chip
      icon="view_timeline"
      [caption]="template.module.name + ' > ' + template.name"
      [selected]="isSelected(template)"
      (click)="isSelected(template) ? removeProduct(template) : addProduct(template)"
      [suffixIcon]="isSelected(template) ? 'close' : undefined"
      >
    </elements-filter-chip>
  }
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
